const deviceHighScoringColumn = [
    {
        name: 'Device Name',
        selector: (row) => row.name_tx,
        sortable: true,
        sortField: 'name_tx',
    },
    {
        name: 'User Name',
        selector: (row) => row.user_name,
        sortable: true,
        sortField: 'user_name',
    },
    {
        name: 'Congregation',
        selector: (row) => row.group_name,
        sortable: true,
        sortField: 'group_name',
    },
    {
        name: 'One Month Back Data',
        selector: (row) => row.one_month_back_data,
        sortable: true,
        sortField: 'one_month_back_data',
    },
    {
        name: 'Two Month Back Data',
        selector: (row) => row.two_month_back_data,
        sortable: true,
        sortField: 'two_month_back_data',
    },
    {
        name: 'Three Month Back Data',
        selector: (row) => row.three_month_back_data,
        sortable: true,
        sortField: 'three_month_back_data',
    },
    {
        name: 'Total Records',
        selector: (row) => row.total,
        sortable: true,
        sortField: 'total',
    },
]

const mobileDeviceHighScoringColumn = [
    {
        name: 'Device Name',
        selector: (row) => row.name_tx,
        sortable: true,
        sortField: 'name_tx',
    },
    {
        name: 'User Name',
        selector: (row) => row.user_name,
        sortable: true,
        sortField: 'user_name',
    },
]

export { deviceHighScoringColumn, mobileDeviceHighScoringColumn }
